import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'connected-next-router';

import { adaptStoreToPageURL } from 'src/adapters/storeToPageURL/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageURL/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

interface UpdatePageURLWithQueryOptions {
  history?: 'push' | 'replace';
}

export const updatePageURLWithQuery = createAsyncThunk<void, UpdatePageURLWithQueryOptions | void>(
  'products/updatePageURLWithQuery',
  async (options, { dispatch, getState }) => {
    const { history = 'push' } = options ?? {};
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { page } = state.productsQuery;
    const urlParams = adaptStoreToPageURL(state, page);
    const href = buildListingsURL(routerPathname, urlParams, state.navigation.hash);
    const as = buildListingsURL(pathname, urlParams, state.navigation.hash);

    dispatch((history === 'push' ? push : replace)(href, as, { shallow: true, scroll: false }));
  },
);
